import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { border } from 'styled-system';
import { Box } from "../../box/src";
import { useTheme } from "../../theme/src";
import { FontAwesomeIcon } from './FontAwesomeIcon';
import { bgSizeToIconSize, colorToBgColor } from './utils';
export const FontAwesomeIconWithBackground = (_a) => {
    var { color, height } = _a, otherProps = __rest(_a, ["color", "height"]);
    const theme = useTheme();
    const iconSize = bgSizeToIconSize(height);
    const bgColor = colorToBgColor(color, theme);
    return (_jsx(BgBox, { alignItems: "center", bg: bgColor, borderRadius: "50%", justifyContent: "center", size: height, children: _jsx(FontAwesomeIcon, Object.assign({ color: color, height: iconSize }, otherProps)) }));
};
const BgBox = styled(Box) `
  ${border}
`;
//# sourceMappingURL=FontAwesomeIconWithBackground.js.map